import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

export function adminGuard() {
  const auth = inject(AuthService);
  const router = inject(Router);

  const email = auth.userEmail()?.trim().toLowerCase();
  const admins = environment.adminEmails?.map((e: string) => e.trim().toLowerCase()) ?? [];

  if (!email || admins.length === 0 || !admins.includes(email)) {
    return router.createUrlTree(['/']);
  }
  return true;
}
